import WaitlistForm from "./WaitlistForm";
import AnimateOnScroll from "./AnimateOnScroll";

const CTA = () => {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      {/* Animated background pattern */}
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(hsl(var(--foreground)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--foreground)) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      {/* Floating gradient */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-[0.03] blur-3xl pointer-events-none"
        style={{
          background: "radial-gradient(circle, hsl(var(--foreground)), transparent 70%)",
          animation: "float 18s ease-in-out infinite",
        }}
      />

      <div className="container mx-auto px-4 relative z-10">
        <AnimateOnScroll>
          <div className="max-w-2xl mx-auto text-center">
            <p className="text-sm uppercase tracking-wider text-muted-foreground mb-4">
              Coming Soon
            </p>
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6 tracking-tight">
              Let your AI agent optimize while you sleep
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Join the waitlist and be among the first to put your website on autopilot.
            </p>

            {/* Waitlist Form */}
            <WaitlistForm source="cta" variant="inline" className="max-w-lg mx-auto" />
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default CTA;
